
import './styles.sass'
import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times-chip.svg'
import { ReactComponent as AddUserIcon } from '@/assets/icons/add-user-icon.svg'
import contactsService from '@/app-domains/contacts/contacts.service'
import modalService from '@/services/modal.service'
import CreateContactModal from '@/components/SideMenu/components/ContactMenu/components/CreateContactModal/CreateContactModal'

export default function MailChip (props) {
  const mail = props.mail
  const isKnown = !!contactsService.findContactByEmail(mail)

  return (
    <div
      key={mail}
      label={mail}
      className='mail-chip'
    >
      <span className='address'>{mail.split('@')[0]}</span>
      <span className='domain'>{`@${mail.split('@')[1]}`}</span>
      {!isKnown && (
        <AddUserIcon className='add-contact-icon' onClick={() =>
          modalService.open(<CreateContactModal type='new' dataToFillInCreationForm={{ emails: [mail] }}/>, true)
        }/>
      )}
      <CrossIcon className='cross-icon' onClick={props.onDeleteHandler}/>
    </div>
  )
}
